// Disposable email blocklist — embedded, NOT npm-imported (supply chain safe)
// Top-impact ~100 domains. Append to DISPOSABLE_DOMAINS to expand coverage.

const DISPOSABLE_DOMAINS = [
  'mailinator.com','mailinator.net','mailinator.org','mailinator2.com',
  '10minutemail.com','10minutemail.net','10minutemail.org','10minutesemail.com','20minutemail.com',
  'tempmail.com','tempmail.org','tempmail.net','tempmail.io','temp-mail.org','temp-mail.io','temp-mail.com',
  'tempmailaddress.com','tempmailo.com','tmpmail.org','tmpmail.net','tempr.email','tempinbox.com','tempemail.net',
  'guerrillamail.com','guerrillamail.net','guerrillamail.org','guerrillamail.biz','guerrillamail.de',
  'guerrillamailblock.com','sharklasers.com','pokemail.net','spam4.me',
  'yopmail.com','yopmail.fr','yopmail.net',
  'throwawaymail.com','throwaway.email','throwaway-mail.com',
  'maildrop.cc','mailnesia.com','mintemail.com','emailondeck.com','getairmail.com','mailcatch.com',
  'meltmail.com','mohmal.com','spamgourmet.com','mytemp.email','fakeinbox.com','nada.email','getnada.com',
  'inboxalias.com','mailtemp.org','dispostable.com','disposablemail.com','discard.email','discardmail.com',
  'mailnull.com','trashmail.com','trashmail.net','trashmail.org','trashmail.de','trashmail.io','trash-mail.com',
  'mytrashmail.com','mailmetrash.com','easytrashmail.com','jetable.org','jetable.fr.nf',
  'fakemail.net','fakemailgenerator.com','burnermail.io','tempinbox.co.uk','tempemailco.com',
  'mailforspam.com','spambox.us','spambog.com','spambog.de','spambog.ru','spamfree24.org',
  'spamhole.com','spaminator.de','spamspot.com','mt2014.com','mt2015.com','mt2009.com',
  'cool.fr.nf','nospam.ze.tc','nomail.xl.cx','mega.zik.dj','speed.1s.fr','mvrht.com','mvrht.net',
  'wegwerfemailadresse.com','wegwerfmail.de','wegwerfmail.net','wegwerfmail.org',
  'rcpt.at','sogetthis.com','thankyou2010.com','emailtemporanea.net','tagyourself.com',
  'inboxbear.com','temporary-mail.net','tempmails.net','instant-mail.de','mailtothis.com',
  'safetymail.info','smashmail.de','smellfear.com','snakemail.com','sneakemail.com',
  'getmaily.ru','asdasd.ru','noemail.com','no-spam.ws','fakeinformation.com',
];

export const DISPOSABLE_EMAIL_DOMAINS = new Set(DISPOSABLE_DOMAINS.map(d => d.toLowerCase()));

export function isDisposableEmail(email) {
  if (!email || typeof email !== 'string') return false;
  const parts = email.trim().toLowerCase().split('@');
  if (parts.length !== 2) return false;
  return DISPOSABLE_EMAIL_DOMAINS.has(parts[1]);
}
